import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const usePricingSetup = () => {
  const [state, setState] = useState({ loaded: false, complete: true, priced: 0 });
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/dealer/pricing/format-defaults").then((r) => alive && setState({ loaded: true, complete: r.data.pricing_setup_complete, priced: r.data.formats.filter((f) => f.resale_per_sqft != null).length })).catch(() => alive && setState({ loaded: true, complete: true, priced: 0 }));
    load();
    window.addEventListener("dealer:pricing-changed", load);
    return () => { alive = false; window.removeEventListener("dealer:pricing-changed", load); };
  }, []);
  return state;
};

// ID-062: dealer resale prices are optional — the gate never blocks browsing, samples, projects, sourcing, reservations or
// wholesale orders; resale prices are requested where a customer-facing price is shown (Customer View).
export const PricingGate = ({ children }) => children;
